var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.841 18.683C6.05 18.683 2.125 13.927 2 6h3.427c.124 5.834 2.617 8.244 4.61 8.751V6h3.24v5.01c1.994-.19 4.05-2.473 4.736-5.01h3.24c-.561 3.107-2.804 5.39-4.362 6.342 1.62.76 4.174 2.726 5.109 6.34h-3.551c-.748-2.409-2.68-4.248-5.172-4.501v4.502z"
  })));
};
export default SvgVk;